<script>
  import Layer from './Layer.svelte'
  import Octicon from 'components/primer/Octicon.svelte'
  import SelectDataset from './SelectDataset.svelte'

  export let datasets

  import { attributes, layers } from 'modules/stores.js'
  import { preferences } from 'modules/preferences.js'

  const maxLayers = 3
  $: num = $layers.length
  $: empty = num === 0
  $: full = num >= maxLayers

  // TODO: improve the creation of a new layer
  const addLayer = () => {
    if (!$attributes || $attributes.length === 0 || full) {
      return
    }
    const layer = {
      mode: preferences.mode,
      attribute: $attributes[0],
    }
    $layers = [...$layers, layer]
  }

  const deleteLayer = i => _ => {
    if (i < num) {
      $layers = $layers.filter((l, j) => i !== j)
    }
  }
</script>

<style>

</style>

<div class="Box">
  <div class="Box-header">
    <SelectDataset {datasets} />
  </div>
  {#if empty}
    <div class="Box-body" class:blankslate={empty}>
      <img
        src="https://ghicons.github.com/assets/images/light/Pull%20Request.png"
        alt=""
        class="mb-3" />
      <h3 class="mb-1">Explore your data.</h3>
      <p>
        You can divide your screen in recursive grids, filtering the data by
        column attributes.
      </p>
      <button
        class="btn btn-primary my-3"
        type="button"
        on:click|preventDefault={addLayer}>
        Create the first grid
      </button>
      <p>
        <a href="https://projet.liris.cnrs.fr/mi2/" title="Project M2i">
          Learn more
          <Octicon
            symbol="link-external"
            class="text-small"
            height="10"
            width="10"
            viewbox="0 0 16 16" />
        </a>
      </p>
    </div>
  {:else}
    <ul>
      {#each $layers as layer, i}
        <Layer bind:layer title="Layer {i + 1}" on:delete={deleteLayer(i)} />
      {/each}
    </ul>
    <div class="Box-footer text-right">
      <button
        class="btn btn-sm btn-outline"
        on:click|preventDefault={addLayer}
        disabled={full}>
        Add a grid
      </button>
    </div>
  {/if}
</div>
